import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ValidationGroup } from '@bingads-webui-react/validation';
import { Campaign, AssetGroup } from '@bingads-webui/campaign-odata-schemas';

export const CampaignValidationGroup = ({
  data, onDataChange, i18n, children, stopPropagation,
}) => {
  const onValidate = useCallback((results) => {
    onDataChange({
      data: prevData => ({
        ...prevData,
        campaign: {
          ...prevData.campaign,
          ...results.data,
        },
      }),
      isValid: results.isValid,
      isDirty: results.isDirty,
    });
  }, [onDataChange]);

  return (
    <ValidationGroup
      validationProps={{
        schema: Campaign,
        onValidate,
        data,
        i18n,
        stopPropagation,
      }}
    >
      {children}
    </ValidationGroup>
  );
};

CampaignValidationGroup.propTypes = {
  data: PropTypes.shape({}),
  onDataChange: PropTypes.func.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
  stopPropagation: PropTypes.bool,
};

CampaignValidationGroup.defaultProps = {
  data: {},
  children: null,
  stopPropagation: false,
};

export const AssetGroupValidationGroup = ({
  data, onDataChange, i18n, children,
}) => {
  const onValidate = useCallback((results) => {
    onDataChange({
      data: prevData => ({
        ...prevData,
        assetGroup: {
          ...prevData.assetGroup,
          ...results.data,
        },
      }),
      isValid: results.isValid,
      isDirty: results.isDirty,
    });
  }, [onDataChange]);

  return (
    <ValidationGroup
      validationProps={{
        schema: AssetGroup,
        onValidate,
        data,
        i18n,
      }}
    >
      {children}
    </ValidationGroup>
  );
};

AssetGroupValidationGroup.propTypes = {
  data: PropTypes.shape({}),
  onDataChange: PropTypes.func.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};

AssetGroupValidationGroup.defaultProps = {
  data: {},
  children: null,
};
